module.exports = __webpack_public_path__ + "static/media/default-template-2.af1bc766.png";